module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-provider.b115f47c.svg";